export enum InvoiceStatus {
  Complete = "complete",
  Pending = "pending",
}
